interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`w-9 h-9 flex items-center justify-center rounded-md border text-sm transition-colors ${
          page === 1
            ? 'border-background-200 text-foreground-300 cursor-not-allowed'
            : 'border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 cursor-pointer'
        }`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer ${
            p === page
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700'
          }`}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`w-9 h-9 flex items-center justify-center rounded-md border text-sm transition-colors ${
          page === totalPages
            ? 'border-background-200 text-foreground-300 cursor-not-allowed'
            : 'border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 cursor-pointer'
        }`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}